import { useTranslation } from "react-i18next";
import GasStationFuelAmountSlider from "@/domains/gasStation/components/slider/GasStationFuelAmountSlider.tsx";

type Props = {
  selectedFuelAmount: number;
  vehicleFuelAmount: number;
  vehicleFuelMaxAmount: number;
  isElectric?: boolean;
  onChange: (value: number) => void;
};
export default function GasStationFuelAmount({
  selectedFuelAmount,
  vehicleFuelAmount,
  vehicleFuelMaxAmount,
  isElectric,
  onChange,
}: Props) {
  const { t } = useTranslation("gasStation");

  const values = [0, 25, 50, 75, 100].map((percent) => (vehicleFuelMaxAmount * percent) / 100);

  return (
    <div className="flex flex-col gap-3.5 px-[1.875rem] -mx-[1.875rem] ">
      <div className="flex items-center justify-between">
        <div className="text-12 font-medium text-white uppercase">
          {t(isElectric ? "gasStation.percentQuantity" : "gasStation.literQuantity")}:
        </div>
        <div className="text-14 font-bold text-accent">
          {vehicleFuelMaxAmount === selectedFuelAmount
            ? "FULL"
            : `${selectedFuelAmount}${isElectric ? "%" : "L"}`}
        </div>
      </div>
      <GasStationFuelAmountSlider
        value={selectedFuelAmount}
        values={values}
        min={0}
        max={vehicleFuelMaxAmount}
        step={1}
        onChange={(newAmount) => {
          const remaining = Math.max(0, vehicleFuelMaxAmount - vehicleFuelAmount);
          const int = Math.floor(newAmount);
          const amount = int > remaining ? Math.floor(remaining) : int;
          onChange(amount);
        }}
        className="py-2"
      />
    </div>
  );
}
